import React, { useEffect, useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { DialogAction, useModal } from '../../../../function/useModal';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';
import { JudgeSettingItem } from '../JudgeSetting/JudgeSetting';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import ItemComboBoxStr, { ComboBoxItemTypeS } from '../../../atoms/ComboBox/ItemComboBoxStr';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Checkbox, TextField } from '@material-ui/core';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import { useTranslation } from 'react-i18next';
import SimpleDialog from '../../../atoms/Dialog/SimpleDialog';
import {
  PLCcollectSettingType,
  KIND_NO_NAME_SET,
  NAME_ITEM_SET,
  LOG_INT_SET,
  MulDataType,
  DATA_UNIT,
  GetConanMeasureName,
  IsIoTZeroGyakuSetting,
} from './CollectSettingDefine';
import { NAME_DEV_SET } from '../../../../function/NameDevSetModel';
import dayjs from 'dayjs';
import JudgeSettingDialog, { JudgeSettingDialogResponse } from '../JudgeSetting/JudgeSettingDialog';
import NumericEntry_inputEx from '../../../atoms/Input/NumericEntry_inputEx';
import NumericFormatEntry_input from '../../../atoms/Input/NumericFormatEntry_input';
import { SpeedKind, MeasureHighKind } from '../../../../Constant';
import { IsConanAirPlc } from '../../../../function/PlcNoModel';

type CollectSettingItemIoTDialogProps = {
  dialog: DialogAction<CollectSettingItemIoTDialogResponse>;
  target: PLCcollectSettingType;
  index: number;
  kindNoNameList: KIND_NO_NAME_SET[];
  nameDevList: NAME_DEV_SET[];
  nameItemList: NAME_ITEM_SET[];
  logIntList: LOG_INT_SET[];
  mulList: MulDataType[];
  dataUnitList: DATA_UNIT[];
  measCombos: ComboBoxItemTypeS[];
  devCombos: ComboBoxItemTypeS[];
  itemCombos: ComboBoxItemTypeS[];
  mulCombos: ComboBoxItemTypeS[];
  unitCombos: ComboBoxItemTypeS[];
  logIntCombos: ComboBoxItemTypeS[];
  avgCombos: ComboBoxItemType[];
  updateMotorSensor: (target: PLCcollectSettingType, index: number, chk: boolean) => boolean;
  updateRotClc: (target: PLCcollectSettingType, index: number, chk: boolean) => boolean;
};

export type CollectSettingItemIoTDialogResponse = {
  result: PLCcollectSettingType;
};

const useStyles = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 300px)',
    },
    tableScroll: {
      overflowX: 'scroll',
      overflowY: 'auto',
    },
    tableHeader: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
      padding: '1px',
      minWidth: '120px',
      borderCollapse: `collapse`,
    },
    textAlignRightCell: {
      textAlign: 'right',
    },
    textAlignCenterCell: {
      textAlign: 'center',
    },
    tableTd: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0px',
      paddingLeft: '5px',
      borderCollapse: `collapse`,
      zIndex: 0,
      textAlign: 'center',
    },
    table_no_border_td: {
      borderTop: '0px',
      borderBottom: '0px',
      borderLeft: '0px',
      borderRight: '1px',
      borderRightStyle: 'solid',
      borderRightColor: '#dcdcdc',
      padding: '0px',
      minWidth: '80px',
      height: '30px',
      borderCollapse: `collapse`,
    },
    table_td_noValue: {
      borderTop: '0px',
      borderBottom: '0px',
      borderLeft: '0px',
      borderRight: '1px',
      borderRightStyle: 'solid',
      borderRightColor: '#dcdcdc',
      padding: '0px',
      height: '30px',
      borderCollapse: `collapse`,
      background: 'silver',
    },
    button: {
      width: '150px',
    },
    labelStyle: {
      fontSize: '12px',
    },
    textField: {
      flexGrow: 1,
      height: '100%',
      width: '98%',
      borderBottom: '1px solid #000000',
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      border: 'none',
      padding: '0px',
      backgroundColor: 'transparent',
    },
    // buttonAutoFreqSet: {
    //   width: '200px',
    // },
  })
);
const IsItemRST = (itemNo: number): boolean => {
  return itemNo >= 3 && itemNo <= 5;
};
const IsItemVibration = (itemNo: number): boolean => {
  return itemNo == 1 || itemNo == 2 || itemNo == 7 || itemNo == 8;
};
const IsInverter = (devs: NAME_DEV_SET[], devIndex: string): boolean => {
  const dno = parseInt(devIndex);
  const nds = devs.find((dv) => dv.DEV_INDEX === dno);
  if (nds) {
    return nds.INV_DRV_ON > 0;
  }
  return false;
};

const CollectSettingItemIoTDialog: React.FC<CollectSettingItemIoTDialogProps> = (
  props: CollectSettingItemIoTDialogProps
) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);
  const [items, setItems] = useState<JudgeSettingItem[]>([]);
  const [item, setItem] = useState<PLCcollectSettingType>({ ...props.target });

  const [isExecute, setIsExecute] = useState<boolean>(props.target.IsExecute);
  const [kind, setKind] = useState<string>(`${props.target.NameNo}_${props.target.Speed}`);
  const [machineIdx, setMachineIdx] = useState<string>(props.target.MachineIndex);
  const [itemNameNo, setItemNameNo] = useState<number>(props.target.ItemNameNo);
  const [logPeriod, setLogPeriod] = useState<number>(props.target.LoggingPeriodMinute);
  const [startTime, setStartTime] = useState<string>(
    props.target.LoggingStartTime == undefined ? '' : dayjs(props.target.LoggingStartTime).format('YYYY-MM-DD HH:mm:ss')
  );
  const [dUpper, setDUpeer] = useState<number>(parseFloat(props.target.DigitalValueUpper));
  const [dLower, setDLower] = useState<number>(parseFloat(props.target.DigitalValueLower));
  const [eUpper, setEUpeer] = useState<number>(parseFloat(props.target.EngineeringValueUpper));
  const [eLower, setELower] = useState<number>(parseFloat(props.target.EngineeringValueLower));
  const [rTUpper, setRTUpper] = useState<number>(parseFloat(props.target.RealtimeTrendValueUpper));
  const [rTUpperUpper, setRTUpperUpper] = useState<number>(parseFloat(props.target.RealtimeTrendValueUpperUpper));
  const [mul, setMul] = useState<number>(props.target.Mul);
  const [unit, setUnit] = useState<string>(props.target.UnitSymbol);
  const [isMotor, setIsMotor] = useState<boolean>(props.target.StartDet === 1);
  const [avg, setAvg] = useState<number>(props.target.AvgPrc);
  const [isEnvSav, setIsEnvSav] = useState<boolean>(props.target.EnvSav);
  const [isRotClc, setIsRotClc] = useState<boolean>(props.target.RotClc);
  const [note, setNote] = useState<string>(props.target.Note);

  const measSubCombos = props.measCombos
    .filter((cmb) => {
      return cmb.key.endsWith(props.target.Speed.toString());
    })
    .concat({ key: `0_${props.target.Speed}`, name: '-' });

  const [flgJdg, jdgDlg] = useModal<JudgeSettingDialogResponse>();

  const [jdgCombos, setJdgCombos] = useState<ComboBoxItemType[]>([]);
  const [clcCombos, setClcCombos] = useState<ComboBoxItemType[]>([]);
  const [almCombos, setAlmCombos] = useState<ComboBoxItemType[]>([]);

  const [flgUpdate, setFlgUpdate] = useState<boolean>(false);
  const [flgConfirm, confirmDlg] = useModal<ConfirmDialogResponse>();
  const [msgConfirm, setMsgConfirm] = useState<string>();

  //APIレスポンスダイアログ
  const [messageDialogOpen, setMessageDialogOpen] = React.useState(false);
  const [showTitle, setShowTitle] = React.useState<string>('');
  const [showMessage, setShowMessage] = React.useState<string>('');

  const changeExecute = (exec: boolean) => {
    setItem({ ...item, IsExecute: exec, isIotEdit: true });
    setIsExecute(exec);
    setFlgUpdate(true);
  };
  const changeKind = (kind: string) => {
    const prm = kind.split('_');
    setItem({ ...item, MeasureKindNo: prm[0], NameNo: parseInt(prm[0]), Speed: parseInt(prm[1]) });
    // item.MeasureKindNo = prm[0];
    // item.NameNo = parseInt(prm[0]);
    // item.Speed = parseInt(prm[1]);
    setKind(kind);
    setFlgUpdate(true);
  };
  const changeMachineIdx = (midx: string) => {
    setMsgConfirm(
      t(
        'CollectSettingItemDialog.選択したタグの情報をすべて削除',
        '選択したタグの情報をすべて削除しますがよろしいですか？'
      )
    );
    confirmDlg
      .open()
      .apply((_) => {
        setItem({
          ...item,
          MachineIndex: midx,
          DigitalValueUpper: '0',
          DigitalValueLower: '0',
          EngineeringValueUpper: '0',
          EngineeringValueLower: '0',
          Mul: 0,
          UnitSymbol: '',
          RealtimeTrendValueUpper: '0',
          RealtimeTrendValueUpperUpper: '0',
          AvgPrc: 0,
          EnvSav: false,
          Note: '',
        });
        setMachineIdx(midx);
        setDUpeer(0);
        setDLower(0);
        setEUpeer(0);
        setELower(0);
        setMul(0);
        setUnit('');
        // setIsMotor(false);
        setRTUpper(0);
        setRTUpperUpper(0);
        setAvg(0);
        setIsEnvSav(false);
        setIsRotClc(false);
        setNote('');
        setFlgUpdate(true);
      })
      .cancel((_) => { });
  };
  const changeItemNameNo = (ino: number) => {
    setItem({ ...item, ItemNameNo: ino });
    // item.ItemNameNo = ino;
    setItemNameNo(ino);
    setFlgUpdate(true);
  };
  // const changeLogPeriod = (period: number) => {
  //   setItem({...item, LoggingPeriodMinute: period});
  //   // item.LoggingPeriodMinute = period;
  //   setLogPeriod(period);
  //   setFlgUpdate(true);
  // };
  // const changeStartTime = (time: Date) => {
  //   setItem({...item, LoggingStartTime:dayjs(time).toDate()});
  //   // item.LoggingStartTime = dayjs(time).toDate();
  //   setStartTime(dayjs(time).format('YYYY-MM-DD HH:mm:ss'));
  //   setFlgUpdate(true);
  // };
  const changeDUpper = (val: number) => {
    setItem({ ...item, DigitalValueUpper: val.toString() });
    // item.DigitalValueUpper = val.toString();
    setDUpeer(val);
    setFlgUpdate(true);
  };
  const changeDLower = (val: number) => {
    setItem({ ...item, DigitalValueLower: val.toString() });
    // item.DigitalValueLower = val.toString();
    setDLower(val);
    setFlgUpdate(true);
  };
  const changeEUpper = (val: number) => {
    setItem({ ...item, EngineeringValueUpper: val.toString() });
    // item.EngineeringValueUpper = val.toString();
    setEUpeer(val);
    setFlgUpdate(true);
  };
  const changeELower = (val: number) => {
    setItem({ ...item, EngineeringValueLower: val.toString() });
    // item.EngineeringValueLower = val.toString();
    setELower(val);
    setFlgUpdate(true);
  };
  const changeRTUpper = (val: number) => {
    setItem({ ...item, RealtimeTrendValueUpper: val.toString() });
    // item.RealtimeTrendValueUpper = val.toString();
    setRTUpper(val);
    setFlgUpdate(true);
  };
  const changeRTUpperUpper = (val: number) => {
    setItem({ ...item, RealtimeTrendValueUpperUpper: val.toString() });
    // item.RealtimeTrendValueUpperUpper = val.toString();
    setRTUpperUpper(val);
    setFlgUpdate(true);
  };
  const changeMul = (val: number) => {
    setItem({ ...item, Mul: val });
    // item.Mul = val;
    setMul(val);
    setFlgUpdate(true);
  };
  const changeUnit = (val: string) => {
    setItem({ ...item, UnitSymbol: val });
    // item.UnitSymbol = val;
    setUnit(val);
    setFlgUpdate(true);
  };
  /**
   * モータ起動状態検出センサ指定チェック
   * @param chk
   */
  const changeMotor = (chk: boolean) => {
    if (chk) {
      if (IsItemRST(item.ItemNameNo)) {
        if (props.updateMotorSensor(item, props.index, chk)) {
          setItem({ ...item, StartDet: 1 });
          setIsMotor(true);
          setFlgUpdate(true);
        }
      }
    } else {
      setItem({ ...item, StartDet: 0 });
      setIsMotor(false);
      setFlgUpdate(true);
    }
  };
  const changeAvg = (val: number) => {
    setItem({ ...item, AvgPrc: val });
    // item.AvgPrc = val;
    setAvg(val);
    setFlgUpdate(true);
  };
  /**
   * エンベロープ処理チェック
   * @param chk
   */
  // const changeEnvSav = (chk: boolean) => {
  //   setFlgUpdate(true);
  //   if (chk) {
  //     if (IsItemVibration(item.ItemNameNo)) {
  //       setItem({ ...item, EnvSav: chk });
  //       setIsEnvSav(chk);
  //       setFlgUpdate(true);
  //     }
  //   } else {
  //     setItem({ ...item, EnvSav: chk });
  //     setIsEnvSav(chk);
  //     setFlgUpdate(true);
  //   }
  // };
  /**
   * 回転周波数算出センサチェック
   * @param chk
   */
  const changeRotClc = (chk: boolean) => {
    if (chk) {
      if (IsItemRST(item.ItemNameNo)) {
        if (IsInverter(props.nameDevList, item.MachineIndex)) {
          if (props.updateRotClc(item, props.index, chk)) {
            setItem({ ...item, RotClc: chk });
            setIsRotClc(chk);
            setFlgUpdate(true);
          }
        }
      }
    } else {
      props.updateRotClc(item, props.index, chk);
      setItem({ ...item, RotClc: chk });
      setIsRotClc(chk);
      setFlgUpdate(true);
    }
  };
  const changeNote = (text: string) => {
    setItem({ ...item, Note: text });
    // item.Note = text;
    setNote(text);
    setFlgUpdate(true);
  };
  const dispJudge = () => {
    jdgDlg
      .open()
      .apply((resp) => { })
      .cancel((resp) => { });
  };
  /**
   * 速度・変位判定マスク変更event
   * @param text
   */
  const changeDspMskOn = (value: number) => {
    console.debug(['changeDspMskOn', value]);
    setItem({ ...item, DispMaskOn: value });
    setFlgUpdate(true);
  };

  const jdgdlgElem = flgJdg ? (
    <JudgeSettingDialog
      plcCollectSetting={item}
      dialog={jdgDlg}
      plcNo={parseInt(props.target.PLCNo)}
      aiCard={parseInt(props.target.AICardNo)}
      aiCh={parseInt(props.target.ChannelNo)}
      onChangeDspMskOn={changeDspMskOn}
    />
  ) : null;

  const confirm = flgConfirm ? (
    <ConfirmDialog
      dialog={confirmDlg}
      message={msgConfirm}
      action={t('CollectSettingItemDialog.はい', 'はい')}
      cancel={t('CollectSettingItemDialog.いいえ', 'いいえ')}
    />
  ) : null;

  /**
   * 計測種別セル表示
   * @returns
   */
  const mesureCell = () => {
    if (IsConanAirPlc(props.target.PLCNo)) {
      return <TableCell className={classes.tableTd}>{GetConanMeasureName(props.kindNoNameList)}</TableCell>;
    }
    else if (IsIoTZeroGyakuSetting(props.target)) {
      return <TableCell className={classes.tableTd}>{measSubCombos.find((row) => row.key === kind)?.name ?? ""}</TableCell>
    }
    else {
      return (
        <TableCell className={classes.tableTd}>
          <ItemComboBoxStr
            itemList={measSubCombos}
            label=""
            value={kind}
            onChangeEvent={(e) => {
              if (typeof e.target.value === 'string') {
                changeKind(e.target.value);
              }
            }}
          />
        </TableCell>
      );
    }
  };

  /**
   * 機器番号セル表示
   * @returns
   */
  const devNoCell = () => {
    let devNo = props.nameDevList.find((item) => item.DEV_INDEX === Number(props.target.MachineIndex))?.DEV_NO;
    return <TableCell className={classes.tableTd}>{devNo ?? ''}</TableCell>;
  };

  /**
   * 項目名称セル表示
   * @returns
   */
  const itemNameCell = () => {
    if (IsConanAirPlc(props.target.PLCNo)) {
      let itemName = props.nameItemList.find((item) => item.ITM_NAME_NO === Number(props.target.ItemNameNo))?.ITM_NAME;
      return <TableCell className={classes.tableTd}>{itemName ?? ''}</TableCell>;
    } else if (IsIoTZeroGyakuSetting(props.target)) {
      return <TableCell className={classes.tableTd}>{props.itemCombos.find((row) => row.key === itemNameNo.toString())?.name ?? ""}</TableCell>
    }
    else {
      return (
        <TableCell className={classes.tableTd}>
          <ItemComboBoxStr
            itemList={props.itemCombos}
            label=""
            value={itemNameNo.toString()}
            onChangeEvent={(e) => {
              if (typeof e.target.value === 'string') {
                changeItemNameNo(parseInt(e.target.value));
              } else if (typeof e.target.value === 'number') {
                changeItemNameNo(e.target.value);
              }
            }}
          />
        </TableCell>
      );
    }
  };
  /**
   * デジタル値
   * @returns
   */
  const digitalCell = () => {
    if (IsConanAirPlc(props.target.PLCNo) || IsIoTZeroGyakuSetting(props.target)) {
      return <TableCell className={classes.table_td_noValue}></TableCell>;
    } else {
      return (
        <TableCell className={classes.tableTd}>
          <Table>
            <TableRow>
              <TableCell className={classes.table_no_border_td} style={{ width: '124px' }}>
                <NumericFormatEntry_input
                  className={classes.textField}
                  value={dUpper}
                  allowNegative={true}
                  onChange={(val) => {
                    changeDUpper(val);
                  }}
                />
              </TableCell>
              <TableCell className={classes.table_no_border_td} style={{ width: '124px' }}>
                <NumericFormatEntry_input
                  className={classes.textField}
                  value={dLower}
                  allowNegative={true}
                  onChange={(val) => {
                    changeDLower(val);
                  }}
                />
              </TableCell>
            </TableRow>
          </Table>
        </TableCell>
      );
    }
  };
  /**
   * 工学値
   * @returns
   */
  const engineeringCell = () => {
    if (IsConanAirPlc(props.target.PLCNo) || IsIoTZeroGyakuSetting(props.target)) {
      return <TableCell className={classes.table_td_noValue}></TableCell>;
    } else {
      return (
        <TableCell className={classes.tableTd}>
          <Table>
            <TableRow>
              <TableCell className={classes.table_no_border_td} style={{ width: '124px' }}>
                <NumericFormatEntry_input
                  className={classes.textField}
                  value={eUpper}
                  allowNegative={true}
                  onChange={(val) => {
                    changeEUpper(val);
                  }}
                />
              </TableCell>
              <TableCell className={classes.table_no_border_td} style={{ width: '124px' }}>
                <NumericFormatEntry_input
                  className={classes.textField}
                  value={eLower}
                  allowNegative={true}
                  onChange={(val) => {
                    changeELower(val);
                  }}
                />
              </TableCell>
            </TableRow>
          </Table>
        </TableCell>
      );
    }
  };
  /**
   * 乗率
   * @returns
   */
  const mulCell = () => {
    if (IsConanAirPlc(props.target.PLCNo) || IsIoTZeroGyakuSetting(props.target)) {
      return <TableCell className={classes.table_td_noValue}></TableCell>;
    } else {
      return (
        <TableCell className={classes.tableTd}>
          <ItemComboBoxStr
            itemList={props.mulCombos}
            label=""
            value={mul.toString()}
            onChangeEvent={(e) => {
              if (typeof e.target.value === 'string') {
                changeMul(parseInt(e.target.value));
              } else if (typeof e.target.value === 'number') {
                changeMul(e.target.value);
              }
            }}
          />
        </TableCell>
      );
    }
  };
  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        fullWidth={true}
        maxWidth="lg"
        onEntered={(e) => { }}
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({ result: item });
          } else {
            props.dialog.cancel();
          }
        }}
      >
        <DialogTitle>{t('CollectSettingItemDialog.設定編集', '設定編集')}</DialogTitle>
        <DialogContent>
          <div>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableCell className={classes.tableHeader}>{t('CollectGridHeader.実行', '実行')}</TableCell>
                  {/* <TableCell className={classes.tableHeader}>
                    {t('CollectGridHeader.PLC','PLC')}
                  </TableCell> */}
                  {/* <TableCell className={classes.tableHeader}>
                    {t('CollectGridHeader.ユニット','ユニット')}<br/>{t('CollectGridHeader.形式','形式')}
                  </TableCell> */}
                  {/* <TableCell className={classes.tableHeader}>
                    {t('CollectGridHeader.AIカード','AIカード')}
                  </TableCell> */}
                  <TableCell className={classes.tableHeader}>{t('CollectGridHeader.機器番号', '機器番号')}</TableCell>
                  <TableCell className={classes.tableHeader}>{t('CollectGridHeader.機器名称', '機器名称')}</TableCell>
                  <TableCell className={classes.tableHeader}>{t('CollectGridHeader.CH', 'CH')}</TableCell>
                  <TableCell className={classes.tableHeader}>{t('CollectGridHeader.信号種別', '信号種別')}</TableCell>
                  <TableCell className={classes.tableHeader}>{t('CollectGridHeader.項目名称', '項目名称')}</TableCell>
                  <TableCell className={classes.tableHeader}>
                    <Table>
                      <TableRow>
                        <TableCell colSpan={2} className={classes.tableHeader} width={'160px'}>
                          {t('CollectGridHeader.デジタル値', 'デジタル値')}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.tableHeader}>{t('CollectGridHeader.上限値', '上限値')}</TableCell>
                        <TableCell className={classes.tableHeader}>{t('CollectGridHeader.下限値', '下限値')}</TableCell>
                      </TableRow>
                    </Table>
                  </TableCell>
                  <TableCell className={classes.tableHeader}>
                    <Table>
                      <TableRow>
                        <TableCell colSpan={2} className={classes.tableHeader}>
                          {t('CollectGridHeader.工学値', '工学値')}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.tableHeader}>{t('CollectGridHeader.上限値', '上限値')}</TableCell>
                        <TableCell className={classes.tableHeader}>{t('CollectGridHeader.下限値', '下限値')}</TableCell>
                      </TableRow>
                    </Table>
                  </TableCell>
                  {/* <TableCell className={classes.tableHeader}>{t('CollectGridHeader.ロギング周期','ロギング周期')}</TableCell> */}
                  {/* <TableCell className={classes.tableHeader} style={{minWidth: '160px'}}>{t('CollectGridHeader.ロギング開始時刻','ロギング開始時刻')}</TableCell> */}
                  <TableCell className={classes.tableHeader}>{t('CollectGridHeader.乗率', '乗率')}</TableCell>
                  <TableCell className={classes.tableHeader}>{t('CollectGridHeader.単位', '単位')}</TableCell>
                  <TableCell className={classes.tableHeader}>
                    {t('CollectGridHeader.判定値設定', '判定値設定')}
                  </TableCell>

                  {/* <TableCell className={classes.tableHeader}>
                    {t('CollectGridHeader.温度', '温度')}
                    <br />
                    {t('CollectGridHeader.上限異常', '上限異常')}
                  </TableCell>
                  <TableCell className={classes.tableHeader}>
                    {t('CollectGridHeader.温度', '温度')}
                    <br />
                    {t('CollectGridHeader.上上限異常', '上上限異常')}
                  </TableCell> */}
                  <TableCell className={classes.tableHeader}>
                    {t('CollectGridHeader.アベレージング処理', 'アベレージング処理')}
                  </TableCell>
                  {/* <TableCell className={classes.tableHeader}>
                    {t('CollectGridHeader.エンベロープ処理', 'エンベロープ処理')}
                  </TableCell> */}
                  <TableCell className={classes.tableHeader}>
                    {t('CollectGridHeader.モータ起動状態', 'モータ起動状態')}
                    <br />
                    {t('CollectGridHeader.検出センサ指定', '検出センサ指定')}
                  </TableCell>
                  <TableCell className={classes.tableHeader}>
                    {t('CollectGridHeader.回転周波数', '回転周波数')}
                    <br />
                    {t('CollectGridHeader.算出センサ', '算出センサ')}
                  </TableCell>
                  <TableCell className={classes.tableHeader}>MEMO</TableCell>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableTd + ' ' + classes.textAlignCenterCell}>
                      <Checkbox
                        checked={isExecute}
                        onChange={(e, chk) => {
                          changeExecute(chk);
                        }}
                      />
                    </TableCell>
                    {/* <TableCell className={classes.tableTd}>
                        {props.target.PLCNo}
                    </TableCell>
                    <TableCell className={classes.tableTd}>
                      {props.target.UnitName}
                    </TableCell>
                    <TableCell className={classes.tableTd}>
                      {props.target.AICardNo}
                    </TableCell> */}
                    {/* 機器番号 */}
                    {devNoCell()}
                    {/* 機器名称 */}
                    <TableCell className={classes.tableTd}>
                      {props.nameDevList.find((item) => item.DEV_INDEX === Number(props.target.MachineIndex))?.DEV_NAME}
                    </TableCell>
                    <TableCell className={classes.tableTd}>{props.target.ChannelNo}</TableCell>
                    {/* 計測種別 */}
                    {mesureCell()}
                    {/* 項目名称 */}
                    {itemNameCell()}
                    {/* デジタル値 */}
                    {digitalCell()}
                    {/* 工学値 */}
                    {engineeringCell()}
                    {/* 乗率 */}
                    {mulCell()}
                    <TableCell className={classes.tableTd}>
                      <ItemComboBoxStr
                        itemList={props.unitCombos}
                        label=""
                        value={unit}
                        onChangeEvent={(e) => {
                          if (typeof e.target.value === 'string') {
                            changeUnit(e.target.value);
                          }
                        }}
                      />
                    </TableCell>
                    <TableCell className={classes.tableTd + ' ' + classes.textAlignCenterCell}>
                      <Button variant="outlined" color="secondary" onClick={(e) => dispJudge()}>
                        {t('CollectGridBody.変更', '変更')}
                      </Button>
                    </TableCell>
                    {/* 温度上限異常 */}
                    {/* <TableCell className={classes.table_no_border_td} style={{ width: '124px' }}>
                      <NumericEntry
                        className={classes.textField}
                        value={rTUpper}
                        onChange={(val) => {
                          changeRTUpper(val);
                        }}
                      />
                    </TableCell> */}
                    {/* 温度上上限異常 */}
                    {/* <TableCell className={classes.table_no_border_td} style={{ width: '124px' }}>
                      <NumericEntry
                        className={classes.textField}
                        value={rTUpperUpper}
                        onChange={(val) => {
                          changeRTUpperUpper(val);
                        }}
                      />
                    </TableCell> */}
                    <TableCell className={classes.tableTd}>
                      <ItemComboBox
                        itemList={props.avgCombos}
                        label=""
                        value={avg}
                        onChangeEvent={(e) => {
                          if (typeof e.target.value === 'string') {
                            changeAvg(parseInt(e.target.value));
                          } else if (typeof e.target.value === 'number') {
                            changeAvg(e.target.value);
                          }
                        }}
                      />
                    </TableCell>
                    {/* <TableCell className={classes.tableTd + ' ' + classes.textAlignCenterCell}>
                      <Checkbox checked={isEnvSav} onChange={(e, chk) => changeEnvSav(chk)} />
                    </TableCell> */}
                    {/* <TableCell className={classes.tableTd}>
                      <ItemComboBoxStr
                        itemList={props.itemCombos}
                        label=""
                        value={itemNameNo.toString()}
                        onChangeEvent={(e) => {
                          if (typeof e.target.value === 'string') {
                            changeItemNameNo(parseInt(e.target.value));
                          }else if(typeof e.target.value === 'number'){
                            changeItemNameNo(e.target.value);
                          }
                        }}
                      />
                    </TableCell> */}
                    {/* <TableCell className={classes.tableTd}>
                      <ItemComboBoxStr
                        itemList={props.logIntCombos}
                        label=""
                        value={logPeriod.toString()}
                        onChangeEvent={(e) => {
                          if (typeof e.target.value === 'string') {
                            changeLogPeriod(parseInt(e.target.value));
                          }
                        }}
                      />
                    </TableCell> */}
                    {/* <TableCell className={classes.tableTd}>
                      <ItemCalenderTime
                        label=""
                        textCssString={classes.labelStyle}
                        labelCssString={classes.labelStyle}
                        onChange={(e) => {
                          changeStartTime(dayjs(e).toDate());
                        }}
                        defaultValue={dayjs(startTime).format('YYYY-MM-DD HH:mm:ss')}
                      />
                    </TableCell> */}
                    <TableCell className={classes.tableTd + ' ' + classes.textAlignCenterCell}>
                      <Checkbox checked={isMotor} onChange={(e, chk) => changeMotor(chk)} />
                    </TableCell>
                    <TableCell className={classes.tableTd + ' ' + classes.textAlignCenterCell}>
                      <Checkbox checked={isRotClc} onChange={(e, chk) => changeRotClc(chk)} />
                    </TableCell>
                    <TableCell className={classes.tableTd}>
                      <TextField
                        inputProps={{ maxLength: 32 }}
                        value={note}
                        onChange={(e) => changeNote(e.target.value)}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.button}
            color="primary"
            variant="contained"
            onClick={(e) => {
              console.debug(['- flgUpdate -', flgUpdate]);
              if (flgUpdate) {
                setMsgConfirm(t('CollectSettingItemDialog.設定を更新しますか?', '設定を更新しますか?'));
                confirmDlg
                  .open()
                  .apply((_) => {
                    setIsOpen(false);
                    setMode(true);
                  })
                  .cancel((_) => { });
              } else {
                setIsOpen(false);
                setMode(false);
              }
            }}
          >
            {t('CollectSettingItemDialog.設定', '設定')}
          </Button>
          <Button
            className={classes.button}
            style={{ marginRight: '30px' }}
            color="primary"
            variant="contained"
            onClick={(e) => {
              if (flgUpdate) {
                setMsgConfirm(
                  t(
                    'CollectSettingItemDialog.編集したデータを破棄します。\nよろしいですか?',
                    '編集したデータを破棄します。\nよろしいですか?'
                  )
                );
                confirmDlg
                  .open()
                  .apply((resp) => {
                    setIsOpen(false);
                    setMode(false);
                  })
                  .cancel((_) => { });
              } else {
                setIsOpen(false);
                setMode(false);
              }
            }}
          >
            {t('CollectSettingItemDialog.キャンセル', 'キャンセル')}
          </Button>
        </DialogActions>
      </Dialog>
      {jdgdlgElem}
      {confirm}
      <SimpleDialog
        open={messageDialogOpen}
        onClose={() => setMessageDialogOpen(false)}
        title={showTitle}
        okText={'OK'}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </SimpleDialog>
    </>
  );
};

export default CollectSettingItemIoTDialog;
